import src from "IMAGE";
export default { src, width: 99, height: 105, blurWidth: 0, blurHeight: 0};
